import { DatasetOrdering, DatasetSorting } from "../../../../api/trading"
import { Country, Currency, Instrument, Region, Sector, TradingCompany, SubRegion } from "../types"

export enum DatasetSource {
  BLOOMBERG = "bloomberg",
  INTERNAL = "internal",
}

export type TradingDataset = {
  id: number
  bb_unique: string
  bloomberg_code: string | null
  scient_code: string | null
  name: string
  long_name: string
  currency: Currency | null
  country: Country | null
  sub_region: SubRegion | null
  region: Region | null
  company: TradingCompany | null
  instrument: Instrument | null
  source: string
  security_type: string
  sectors: Sector[]
  seasonality_and_transformation: string | null
  future_release_date: string | null
  created_at: string
  updated_at: string
}

export type DatasetUpdatePayload = {
  name: string
  currency_id: number | null
  country_id: number | null
  company_id: number | null
  instrument_id: number | null
  sub_region_id: number | null
  region_id: number | null
  sectors: Partial<Sector>[]
  seasonality_and_transformation: string | null
}

export type DatasetFilters = {
  codeStartswithParam?: string
  nameParam?: string
  longNameParam?: string
  sourceParam?: DatasetSource
  regionIdParam?: number
  subRegionIdParam?: number
  countryCodeParam?: string[]
  currencyCodeParam?: string[]
  sectorsParam?: number[]
  orderBy?: DatasetOrdering
  sortDirection?: DatasetSorting
}
